import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { screenResize } from '../ui-action';

//TODO: This is a hack to prevent multiple dispatches of the resize action, it can happen 50+ times on some pages
let hasResized = false;

const WindowResizeWrapper = Component => {
    return class extends React.PureComponent {
        componentDidMount() {
            const { resize, width, height } = this.props;
            if ((!width || !height) && !hasResized) {
                hasResized = true;
                resize();
            }
        }

        render() {
            return <Component {...this.props} />;
        }
    };
};

const mapStateToProps = state => ({
    device: state.ui.device,
    width: state.ui.width,
    height: state.ui.height,
    customBreakpoints: state.ui.customBreakpoints,
});
const mapDispatchToProps = dispatch => ({
    resize: () => dispatch(screenResize()),
});

export default compose(connect(mapStateToProps, mapDispatchToProps), WindowResizeWrapper);
